import React, { useState } from 'react';
import styled from 'styled-components';
import { Dialog } from '@mui/material';
import { Close } from '@mui/icons-material';
import { callTypes } from '../../assets/data';

const PrayerTypeDialog = ({ 
  open, 
  onClose, 
  onConfirm,
  request 
}) => {
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleConfirm = () => {
    if (selectedCategory) {
      onConfirm(selectedCategory);
      setSelectedCategory('');
      onClose();
    }
  };

  const handleClose = () => {
    setSelectedCategory('');
    onClose();
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="md"
      fullWidth
    >
      <StyledDialogHeader>
        <h2>Select Category</h2>
        <CloseButton onClick={handleClose}>×</CloseButton>
      </StyledDialogHeader>

      <StyledDialogContent>
        <DialogDescription>
          Please select the category for this prayer request: <strong>{request?.prayer_request?.substring(0, 50)}...</strong>
        </DialogDescription>

        <TypeGrid>
          {callTypes.map(type => (
            <TypeButton
              key={type.id}
              onClick={() => setSelectedCategory(type.type)}
              $selected={selectedCategory === type.type}
            >
              {type.type}
            </TypeButton>
          ))}
        </TypeGrid>

        <ButtonGroup>
          <Button variant="text" onClick={handleClose}>
            Cancel
          </Button>
          <Button 
            variant="primary" 
            onClick={handleConfirm}
            disabled={!selectedCategory}
          >
            Confirm Category
          </Button>
        </ButtonGroup>
      </StyledDialogContent>
    </Dialog>
  );
};

const StyledDialogHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 24px 0 24px;
  border-bottom: 1px solid #E5E7EB;

  h2 {
    margin: 0;
    color: #374151;
    font-size: 1.25rem;
    font-weight: 600;
    font-family: 'Space Grotesk', sans-serif;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #6B7280;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  &:hover {
    background: #F3F4F6;
    color: #374151;
  }
`;

const StyledDialogContent = styled.div`
  padding: 24px;
`;

const DialogDescription = styled.p`
  color: #6B7280;
  font-size: 0.875rem;
  margin-bottom: 24px;
  line-height: 1.5;
`;

const TypeGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
  margin-bottom: 24px;
`;

const TypeButton = styled.button`
  padding: 16px;
  border: 2px solid ${props => props.$selected ? '#2DB3C0' : '#E5E7EB'};
  border-radius: 8px;
  background: ${props => props.$selected ? '#F0FDFF' : 'white'};
  color: ${props => props.$selected ? '#2DB3C0' : '#374151'};
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  font-family: 'Space Grotesk', sans-serif;

  &:hover {
    border-color: #2DB3C0;
    background: ${props => props.$selected ? '#F0FDFF' : '#F8FAFC'};
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;

const Button = styled.button`
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  ${props => props.variant === 'primary' && `
    background: #2DB3C0;
    color: white;
    border: none;

    &:hover:not(:disabled) {
      background: #259AA5;
    }

    &:disabled {
      background: #E5E7EB;
      color: #9CA3AF;
      cursor: not-allowed;
    }
  `}

  ${props => props.variant === 'text' && `
    background: none;
    color: #666666;
    border: none;

    &:hover {
      background: #F3F4F6;
    }
  `}
`;

export default PrayerTypeDialog;

